/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-17 07:55:13
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { Page, Layout, Banner, TextStyle } from '@shopify/polaris';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import MainMenu from 'src/components/containers/main-menu';
import { routes } from 'src/routes';

type Props = {
  selectedPlan: string
};

type ComposedProps = Props & WithI18nProps;

class PlanMigrationComplete extends Component<ComposedProps> {
  render() {
    const { i18n, selectedPlan } = this.props;
    const plusPlanMigration = !!selectedPlan && selectedPlan.includes('plus_');

    return (
      <div className="BC-Page BC-Page__Subscription">
        <MainMenu menuId="" />
        <Page
          title={i18n.translate('AdminHTML.Subscription.Subscription.title')}
          breadcrumbs={[
            {
              content: i18n.translate('AdminHTML.Subscription.Subscription.title'),
              onAction: this.backToSubscriptionPage
            }
          ]}>
          <Layout>
            <Layout.Section>
              <div className="BC-Container__Notifications">
                <Banner
                  title={i18n.translate('AdminHTML.Subscription.PlanMigration.completeTitle', {
                    t1_plan: i18n.translate(
                      `AdminHTML.Subscription.PlanMigration.${
                        plusPlanMigration
                          ? 'completeTitle_t1_plan_plus'
                          : 'completeTitle_t1_plan_premium'
                      }`
                    )
                  })}
                  status="success"
                  action={{
                    content: i18n.translate('AdminHTML.Common.Action.goHome'),
                    onAction: this.goToHomepage
                  }}>
                  <p className="textSetupComplete">
                    {i18n.translate('AdminHTML.Subscription.PlanMigration.completeContent_Thanks', {
                      t1_plus: plusPlanMigration
                        ? i18n.translate(
                            'AdminHTML.Subscription.PlanMigration.completeContent_Thanks_t1_plus'
                          )
                        : ''
                    })}
                  </p>

                  <p className="textSetupComplete">
                    {i18n.translate(
                      'AdminHTML.Subscription.PlanMigration.completeContent_CheckEmail'
                    )}
                  </p>

                  <p className="textSetupComplete">
                    <TextStyle variation="strong">
                      {i18n.translate('AdminHTML.Subscription.PlanMigration.team')}
                    </TextStyle>
                  </p>
                  <p>
                    <TextStyle variation="strong">support-plus@boostcommerce.net</TextStyle>
                  </p>
                </Banner>
              </div>
            </Layout.Section>
          </Layout>
        </Page>
      </div>
    );
  }

  // Go back to subcription page
  backToSubscriptionPage = () => {
    const { history } = this.props;
    history.push(routes.subscription.plan());
  };

  // Go to homepage
  goToHomepage = () => {
    const { history } = this.props;
    history.push(routes.dashboard.view());
  };
}

const mapStateToProps = (state, props) => ({
  selectedPlan: _.get(state.oauth.tenantApp, 'selectedPlan')
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(PlanMigrationComplete));
